import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { activeLanguageKey } from '../config/language.config';

@Injectable({
  providedIn: 'root'
})
export class LanguageInterceptor implements HttpInterceptor {

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const language = localStorage.getItem(activeLanguageKey) || 'pl';
    const headers = req.headers.set('Accept-Language', language);
    return next.handle(req.clone({ headers }));
  }
}
